import React from 'react';

import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    NumberInput,
    NumberInputField,
} from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

import { CustomText } from '@components/Custom-text';

interface FormControlNumberFieldProps {
    name: string;
    label: string;
    size?: string;
    isRequired?: boolean;
    min?: number;
    max?: number;
}

const FormControlNumberField: React.FC<FormControlNumberFieldProps> = ({
    name,
    label,
    isRequired,
    min,
    max,
}) => (
    <Field name={name}>
        {({ field, form: { touched, errors } }: FieldProps) => {
            const isInvalid = !!errors[field.name] && touched[field.name];
            return (
                <FormControl isInvalid={Boolean(isInvalid)}>
                    <Flex>
                        <FormLabel>
                            <Heading color="titleText" size="xs" as="h6">
                                {label}
                            </Heading>
                        </FormLabel>
                        {isRequired ? (
                            <Heading color="red" size="xs" ml={-2}>
                                *
                            </Heading>
                        ) : null}
                    </Flex>
                    <NumberInput {...field} name={name} min={min ?? 0} max={max ?? 999999999}>
                        <NumberInputField />
                    </NumberInput>
                    <FormErrorMessage>
                        <CustomText size="xs" color="red.500">
                            {String(errors[field.name])}
                        </CustomText>
                    </FormErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default FormControlNumberField;
